import React from "react";
import {AssistantChats} from '../assistant';
import {ModelType, ModelTypeID} from "../../api";

export const AiHeadTeacherChats = () => {
    return <AssistantChats modelType={ModelType.HEAD_TEACHER} modelTypeId={ModelTypeID.HEAD_TEACHER}/>;
};

